import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from '../config/app.constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PollsandsurveyService {

  private dataSubject = new BehaviorSubject<string>('Initial data');
  public data$ = this.dataSubject.asObservable();

  couponId: any;
  private data = {};
  private variable = new BehaviorSubject<any>({});

  constructor(
    private apiService: ApiService,
    private http: HttpClient
  ) { }

  sendData(data: string) {
    this.dataSubject.next(data);
  }

  set couponToSet(couponId) {
    this.couponId = couponId;
  }

  get couponToSet() {
    return this.couponId;
  }

  setOption(option, value) {
    this.data[option] = value;
  }

  getOption() {
    return this.data;
  }

  setOptionDynamic(option, value) {
    const options = this.variable.getValue();
    options[option] = value;
    this.variable.next(options);
    // .next will emit a new value to every subscription
  }

  get getOptionDynamic() {
    return this.variable.asObservable();
  }

  getParkByCLAId() {
    return this.apiService.get(`${APIs.getParkByClaId}?claId=${localStorage.getItem('claAdminId')}`).pipe(map(response => {
      return response;
    }))
  }

  getCompanyList(data: any): Observable<any> {
    return this.apiService.post(APIs.getCompanyListFromPark, data).pipe(map(response => {
      return response;
    }));
  }

  getBuildingList(id: string): Observable<any> {
    let parkIdValue = localStorage.getItem('parkId');
    return this.apiService.get(`${APIs.getBuildingByParkId}?parkId=${parkIdValue}`).pipe(map(response => {
      return response;
    }));
    // return this.apiService.get(APIs.getTenantListFromBuilding + '?parkId=' + id).pipe(map(response => {
    //   return response;
    // }));
  }

  getBuildingListMulti(data: any): Observable<any> {
    return this.apiService.post(APIs.getMultiParkBuildingList, data).pipe(map(response => {
      return response;
    }));
  }

  getEventCategory() {
    return this.apiService.get(APIs.GetEventsCategory).pipe(map(response => {
      return response?.list;
    }));
  }

  createNewPollsandSurvey(body?: any): Observable<any> {
    return this.apiService.post(APIs.createNewPollAndSurvey, body).pipe(map(response => {
      return response;
    }));
  }

  getCouponList(): Observable<any> {
    return this.apiService.get(APIs.getAllCouponList).pipe(map(response => {
      // return response?.list;
      return response;
    }));
  }

  getEventList(data): Observable<any> {
    return this.apiService.post(APIs.getEventsPolls, data).pipe(
      map((response) => {
        return response;
      })
    );
  }

  getAllPollsAndSurveyList(): Observable<any> {
    let parkId = localStorage.getItem('parkId');
    return this.apiService.get(APIs.gelAllPollAndSurvey + '?parkId=' + parkId).pipe(map(response => {
      // return response?.list;
      return response;
    }));
  }

  getSurveyDetails(id: string): Observable<any> {
    return this.apiService.get(APIs.getSingleSurveyDetails + '?surveyId=' + id).pipe(map(response => {
      return response;
    }));
  }

  getSurveyAttributes(id: string): Observable<any> {
    return this.apiService.get(APIs.GetSurveyAttribute + '?surveyId=' + id).pipe(map(response => {
      return response;
    }));
  }

  updateNewPollsandSurvey(body?: any): Observable<any> {
    return this.apiService.put(APIs.updateNewPollAndSurvey, body).pipe(map(response => {
      return response;
    }));
  }

  addPollsAndSurveyQuestion(body?: any): Observable<any> {
    return this.apiService.post(APIs.addSurveyQuestion, body).pipe(map(response => {
      return response;
    }));
  }

  getAllSurveyQuestionAnswer(id: string): Observable<any> {
    return this.apiService.get(APIs.getSurveyQuestion + '?SurveyId=' + id).pipe(map(response => {
      return response;
    }));
  }

  removeSurvey(body: any): Observable<any> {
    return this.apiService.post(APIs.removeSurvey, body).pipe(map(response => {
      return response;
    }));
  }

  getStatisticsReportPolls(id: string): Observable<any> {
    return this.apiService.get(APIs.getPollsSurveyStatistics + '?SurveyId=' + id).pipe(map(response => {
      return response;
    }));
  }

  getChartDataByQuestionId(id: string): Observable<any> {
    return this.apiService.get(APIs.getChartDataByQuestionPolls + '?QuestionId=' + id).pipe(map(response => {
      return response;
    }));
  }

  getCuoponDetails(id: string): Observable<any> {
    return this.apiService.get(APIs.getSingleCouponDetails + '?couponId=' + id).pipe(map(response => {
      return response;
    }));
  }

  sendReminderToNon(body?: any): Observable<any> {
    return this.apiService.post(APIs.sendReminderToNonResponder, body).pipe(map(response => {
      return response;
    }));
  }

  getReportDownloadPolls(id: string): Observable<any> {
    return this.apiService.get(APIs.downloadReportPollsSurvey + '?surveyId=' + id).pipe(map(response => {
      return response;
    }));
  }
}
